module.exports = __webpack_public_path__ + "media/images/icons/sheet-a5aaa5e5ec06426139bccc0df9b5931a.svg";